/**
 * 其知网 用户购物卡
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>用户购物卡</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.card_key" style="width:140px" clearable placeholder="输入购物卡号"></el-input>
        类型：
        <el-select size="small" v-model="formInline.type" style="width:140px" placeholder="请选择">
          <el-option v-for="type in cardType" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
        状态：
        <el-select size="small" v-model="formInline.status" style="width:140px" placeholder="请选择">
          <el-option v-for="type in cardStatus" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
        <!-- <el-button size="small" type="primary" icon="el-icon-document-add" title="添加单张购物卡" @click="handleAdd">添加</el-button>

        <el-button size="small" type="primary" icon="" title="批量导入购物卡" @click="handleExport">批量导入</el-button>    -->

        <!-- 上传组件 -->
        <!-- <Upload v-bind:isDialogMode="false" v-bind:uploadUrl="uploadUrl" @callFather="callFather"></Upload> -->

        <!-- <el-button size="small" type="warning" icon="" title="下载导入模板" @click="downloadExcel">下载模板</el-button> -->
        <!-- <el-button size="small" type="warning" icon="" title="批量审核勾选专利" @click="verifyCheckSale">审核</el-button> -->
        <!-- <el-button size="small" type="warning" icon="" title="批量设置勾选专利行业" @click="cateCheckSale">行业设置</el-button> -->
        <!-- <el-button size="small" type="danger" icon="" title="批量删除勾选中的数据" @click="delCheckSale">删除</el-button> -->
      </el-form-item>
      <!-- <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-document-add" @click="handleEdit">添加</el-button>
      </el-form-item> -->
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="40">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="50">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="card_key" align="center" label="购物卡号" show-overflow-tooltip>
      </el-table-column>
      <!-- <el-table-column prop="card_key" align="center" label="购物卡key" width="150px" show-overflow-tooltip>
      </el-table-column> -->
      <el-table-column prop="card_value" align="center" label="购物卡密" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="money" align="center" label="购物卡金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="status" align="center" label="状态" :formatter="statusFormat" width="120px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="name" align="center" label="用户昵称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="head" align="center" label="用户头像" width="80px" show-overflow-tooltip>
        <template slot-scope="scope" v-if="scope.row.head">
        　  <img :src="scope.row.head" height="40px" width="40px"/>
        </template>
      </el-table-column>
      <el-table-column prop="mobile" align="center" label="用户手机号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="begin_time" align="center" label="开始时间" width="150px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="end_time" align="center" label="结束时间" width="150px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="添加时间" width="150px" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" width="250px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="handleWrite(scope.$index, scope.row)" title="核销已使用">核销</el-button>
          <el-button size="mini" type="danger" @click="handleExpired(scope.$index, scope.row)" title="设置为过期">过期</el-button>
          <!-- <el-button size="mini" type="warning" title="审核专利">审核</el-button> -->
          <!-- <el-button size="mini" type="success" @click="handleCate(scope.$index, scope.row)" title="设置行业">行业</el-button>
          <el-button size="mini" type="danger" @click="delSale(scope.$index, scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
     <!-- 添加界面 -->
    <el-dialog :title="title" :visible.sync="addFormVisible" width="50%" @click="closeDialog('addForm')">
      <el-form label-width="120px" :model="addForm" ref="addForm" :rules="addFormRules">
        <el-row>
            <el-form-item label="购物卡key" prop="card_key">
              <el-input size="small" v-model="addForm.card_key"></el-input>
            </el-form-item>
            <el-form-item label="购物卡value" prop="card_value">
              <el-input size="small" v-model="addForm.card_value"></el-input>
            </el-form-item>
            <el-form-item label="类型" prop="type">
              <el-radio-group type="status" v-model="addForm.type"> 
                    <el-radio v-model="addForm.type" :label="1" style="font-size: 25px">20元</el-radio>
                    <el-radio v-model="addForm.type" :label="2">50元</el-radio>
                    <el-radio v-model="addForm.type" :label="3">100元</el-radio>
                    <el-radio v-model="addForm.type" :label="4">200元</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="submitAddForm('addForm')">保存</el-button>
              <el-button size="mini" @click='closeDialog("addForm")'>取消</el-button>
            </el-form-item>
        </el-row>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import { userShopCardPageList, addShopCard, editShopCardStatus, webUrl, expiredShopCard } from '../../api/webMG'
import Pagination from '../../components/Pagination'
// import Upload from '../../components/upload.vue'

//引入ali-oss
import { client, getFileNameUUID } from '@/utils/ali-oss'

import { checkLogin } from '../../utils/util'
export default {
  name: "Upload",
  props: {
    limit: {
    type: Number,
    default: 1
    }
    },
  data() {
    return {

      // 视频上传开始
      fileList: [],//文件列
      showProgress: false,//进度条的显示
      dataObj: {}, //存签名信息
      progress: 0, //进度条数据
      // 视频上传结束

      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, // 控制编辑页面显示与隐藏
      addFormVisible: false,// 控制添加页面显示与隐藏
      uploadUrl: '',
      title: '添加分类',
      excelUrl: '',
      multipleSelection: [],
      cardType: [
        { key: '全部', value: 0 },
        { key: '20元', value: 1 },
        { key: '50元', value: 2 },
        { key: '100元', value: 3 },
        { key: '200元', value: 4 }
      ],
      cardStatus: [
        { key: '全部', value: 0 },
        { key: '未使用', value: 1 },
        { key: '已使用', value: 2 },
        { key: '已过期', value: 3 }
      ],
      listData: [],
      addForm: {
          card_key: '',
          card_value: '',
          type: 0,
          card_money: 0
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel:webUrl + '/admin/shop/importShopCard',
      formInline: {
        page: 1,
        ps: 10,
        status: '',
        type: '',
        card_key: ''
      },
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      // 添加表单验证
      addFormRules: {
        card_key: [{required: true, message: '请填写购物卡key', trigger: 'blur'}],
        card_value: [{required: true, message: '请填写购物卡value', trigger: 'blur'}],
        type: [{required: true, message: '请选择专利类型', trigger: 'blur'}]
      }
    }
  },
  // 注册组件
  components: {
    Pagination, 
    // Upload
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    // 视频上传oss 开始

      // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.excelFormVisible = false
          this.getdata(this.formInline)
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }

    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/market/readExcel',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },
    // 视频上传oss 结束

    // 获取公司列表
    getdata(parameter) {
        console.log(parameter)
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      userShopCardPageList(parameter)
        .then(res => {
          this.loading = false
          console.log(res);
          res = checkLogin(res)
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 显示详情界面
    handleEdit: function(index, row) {
      
      if (row != undefined && row != 'undefined') {
        if(row.status == 3){
          this.$message({
              type: 'info',
              message: '该专利已下架,无法进行审核!'
            })
            return false
        }
        this.editFormVisible = true
        this.title = '专利审核'
        this.infoForm.id = row.id
        this.infoForm.title = row.title
        this.infoForm.icon = row.icon
        this.infoForm.type = row.type
        this.infoForm.sort = row.sort
        this.infoForm.status = row.status
        this.infoForm.note = row.note
        this.infoForm.application_number = row.application_number
      } else {
        this.editFormVisible = true
        this.title = '添加专利'
        this.infoForm.id = ''
        this.infoForm.title = ''
        this.infoForm.icon = ''
        this.infoForm.type = ''
        this.infoForm.sort = ''
        this.infoForm.status = ''
        this.infoForm.note = ''
        this.infoForm.application_number = ''
      }
    },

    // 显示添加页
    handleAdd: function(){
      this.title = '添加购物卡'
      this.addFormVisible = true
      this.addForm.card_key = ''
      this.addForm.card_value = ''
      this.addForm.type = 0
      this.addForm.card_money = 0
    },
    // 图片上传相关
    handleAvatarSuccess(res, file) {
      if(res.code == 200){
          // this.imageUrl = res.data.url;
          this.infoForm.icon = res.data.url
      }else{
          this.$message({
              type: 'error',
              message: res.msg
            })
      }
        // this.imageUrl = URL.createObjectURL(file.raw);
    },
    beforeAvatarUpload(file) {
        // const isJPG = file.type === 'image/jpeg';
        const isJPG = true;
        const isLt2M = file.size / 1024 / 1024 < 2;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 2MB!');
        }
        return isJPG && isLt2M;
    },
    // 显示Excel导入页面
    handleExport: function(){
      this.title = '批量导入购物卡Excel'
      this.excelFormVisible = true
    },
    // 提交添加购物卡
    submitAddForm(addForm){
      this.$refs[addForm].validate(valid => {
        if (valid) {
        if(this.addForm.type == 0){
            this.$message.error('购物卡类型必须选择!')
            return false
        }
        if(this.addForm.type == 1){
            this.addForm.card_money = 20
        }
        if(this.addForm.type == 2){
            this.addForm.card_money = 50
        }
        if(this.addForm.type == 3){
            this.addForm.card_money = 100
        }
        if(this.addForm.type == 4){
            this.addForm.card_money = 200
        }
        addShopCard(this.addForm)
        .then(res => {
            res = checkLogin(res)
            if (res.code == 200) {
            this.$message({
                type: 'success',
                message: res.msg
            })
            this.addFormVisible = false
            this.loading = false
            this.getdata(this.formInline)
            } else {
            this.$message({
                type: 'error',
                message: res.msg
            })
            }
        })
        .catch(err => {
            this.$message.error('系统错误！')
            this.addFormVisible = false
            this.loading = false
        })
    } else {
        return false
    }
      })
    },

    // 专利状态
    statusFormat:function(row,column){
        if(row.status == 1){
            return '未使用'
        }else if(row.status == 2){
            return '已使用'
        }else if(row.status == 3){
            return '已过期'
        }else{
            return '未知'
        }
    },
    // 购物卡核销
    handleWrite:function(index,data){
      if(data.status != 1){
          this.$message({
              type: 'warning',
              message: '该状态不支持核销!'
          })
          return false
      }
      this.$confirm('确定要核销吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const delParam = {card_id:data.id,status:2}
          editShopCardStatus(delParam)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('系统错误,请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消核销'
          })
        })
    },
    // 设置过期
    handleExpired:function(index,data){
        console.log(data)
        if(data.status != 1){
          this.$message({
              type: 'warning',
              message: '该状态不支持核销!'
          })
          return false
      }
      this.$confirm('确定要设置过期吗?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          const delParam = {card_id:data.id,status:3}
          expiredShopCard(delParam)
            .then(res => {
              if (res.code == 200) {
                this.$message({
                  type: 'success',
                  message: res.msg
                })
                this.getdata(this.formInline)
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
            .catch(err => {
              this.loading = false
              this.$message.error('系统错误,请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },

    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      if(formName == 'addForm'){
        this.addFormVisible = false
      }else if(formName == 'verifyForm'){
        this.verifyFormVisible = false
      }else if(formName == 'editForm'){
        this.editFormVisible = false
      }else if(formName == 'cateForm'){
        this.cateFormVisible = false
      }else if(formName == 'cateCheck'){
        this.cateCheckVisible = false
      }else if(formName == 'verifyCheck'){
        this.verifyCheckVisible = false
      }else{
        return false
      }
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/shop/Usershopcard.vue